import { Box, Popover, Text } from '@wix/design-system';
import React from 'react';
export const EllipsisTooltipWrapper = _ref => {
  let {
    children,
    fullText,
    hasEllipsis,
    position = 'top'
  } = _ref;
  const [isTooltipDisplayed, setIsTooltipDisplayed] = React.useState(false);
  return hasEllipsis ? /*#__PURE__*/React.createElement(Popover, {
    theme: "light",
    placement: "top",
    showArrow: true,
    shown: isTooltipDisplayed,
    appendTo: "window",
    moveBy: {
      x: 0,
      y: position === 'top' ? 3 : -3
    },
    dataHook: "ellipsis-tooltip-wrapper",
    onMouseEnter: () => setIsTooltipDisplayed(true),
    onMouseLeave: () => setIsTooltipDisplayed(false)
  }, /*#__PURE__*/React.createElement(Popover.Element, null, children), /*#__PURE__*/React.createElement(Popover.Content, null, /*#__PURE__*/React.createElement(Box, {
    padding: "5px 14px",
    dataHook: "ellipsis-tooltip-content"
  }, /*#__PURE__*/React.createElement(Text, null, fullText)))) : /*#__PURE__*/React.createElement(React.Fragment, null, children);
};
//# sourceMappingURL=EllipsisTooltipWrapper.js.map